import script from "./RecursiveSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecursiveSelector.vue?vue&type=script&setup=true&lang=ts"

import "./RecursiveSelector.vue?vue&type=style&index=0&id=375a7200&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-375a7200"]])

export default __exports__